import React, { useMemo, useState } from 'react';
import { FAQS } from './orbitContent';

const GROUPS = ['All', 'The idea', 'What you get', 'Joining'];

/**
 * Friendly FAQ accordion — used on home and /orbit/faq
 */
function OrbitFaq({
  limit = null,
  showFilters = true,
  groupDefault = 'All',
}) {
  const [group, setGroup] = useState(groupDefault);
  const [openKey, setOpenKey] = useState(null);

  const items = useMemo(() => {
    const filtered =
      group === 'All' ? FAQS : FAQS.filter((f) => f.group === group);
    return limit ? filtered.slice(0, limit) : filtered;
  }, [group, limit]);

  return (
    <div className="orbit-faq">
      {showFilters && (
        <div className="orbit-faq-filters" role="tablist" aria-label="FAQ topics">
          {GROUPS.map((g) => (
            <button
              key={g}
              type="button"
              role="tab"
              aria-selected={group === g}
              className={group === g ? 'is-active' : undefined}
              onClick={() => {
                setGroup(g);
                setOpenKey(null);
              }}
            >
              {g}
            </button>
          ))}
        </div>
      )}

      <div className="orbit-faq-list">
        {items.map((item, i) => {
          const key = `${item.group}-${item.q}`;
          const isOpen = openKey === key;
          const panelId = `orbit-faq-panel-${i}`;
          return (
            <div
              key={key}
              className={`orbit-faq-item${isOpen ? ' is-open' : ''}`}
              style={{ '--faq-i': i % 4 }}
            >
              <button
                type="button"
                className="orbit-faq-q"
                aria-expanded={isOpen}
                aria-controls={panelId}
                onClick={() => setOpenKey(isOpen ? null : key)}
              >
                <span className="orbit-faq-q-main">
                  <span className="orbit-faq-tag">{item.group}</span>
                  <span className="orbit-faq-q-text">{item.q}</span>
                </span>
                <span className="orbit-faq-toggle" aria-hidden="true">
                  {isOpen ? '−' : '+'}
                </span>
              </button>
              <div
                id={panelId}
                className="orbit-faq-panel"
                role="region"
                aria-hidden={!isOpen}
              >
                <p className="orbit-faq-a">{item.a}</p>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default OrbitFaq;
